import * as toastr from 'toastr';
import { OBTER_PARAMETROS } from '../actions/index';

export default function (state = {}, action) {    
    switch (action.type) {            
        case OBTER_PARAMETROS:                                
            if(action.error){
                toastr.error("Erro obtendo parametros.");
                return state;                
            }else{                            
                return action.payload;
            }
        default:
            return state;
    }   
}
